import { Box } from "@mui/material";
import * as images from "../../../../images";
import * as Styles from "./styledFileDetails";
import { useCallback, useRef, useState } from "react";
import ImageViewer from "react-simple-image-viewer";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { DELETE_REQUEST } from "../../../../HooksApi/useApi";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import deleteData from "../../../../HookAxios/delete";
import FileDetailsForm from "./fileDetailsForm";

const urlToObject = async ({ id, image }) => {
  const response = await fetch(image);
  // here image is url/location of image
  const blob = await response.blob();
  const file = new File([blob], `${id}.jpg`, { type: blob.type });
  return file;
};

export function FileComments({ fileData }) {
  //@Initiate
  const { fileId } = useParams();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  //@Component State
  const commentEditImageObjectArray = useRef([]);
  const [expandedComp, setExpandedComp] = useState("");
  const [expandedCom, setExpandedCom] = useState("");
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentReplayImage, setCurrentReplayImage] = useState(0);
  const [isReplayViewerOpen, setIsReplayViewerOpen] = useState(false);
  const [isEditCommentId, setIsEditCommentId] = useState("");

  const token = useSelector((state) => state.Auth.userInfo.token);
  const userId = useSelector((state) => state.Auth.userInfo.data.id);

  //@Async
  const { mutate: deleteComment } = DELETE_REQUEST({
    request: (commentId) =>
      deleteData(
        `work_papers/comment/${commentId}`,
        {},
        {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        }
      ),
    handelOnSettledError,
    handelOnSettledData,
  });

  function handelOnSettledError(error) {
    enqueueSnackbar("حدث خطأ", { variant: "error" });
  }
  function handelOnSettledData(data) {
    queryClient.invalidateQueries(`work_papers_file${fileId}`);
    enqueueSnackbar("تم حذف السؤال بنجاح", { variant: "success" });
  }

  //@Handlers
  const handleChangeComp = (panel) => (event, newExpanded) => {
    setExpandedComp(newExpanded ? panel : false);
  };
  const handleChangeCom = (panel) => (event, newExpanded) => {
    setExpandedCom(newExpanded ? panel : false);
  };
  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);
  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const openReplayImageViewer = useCallback((index) => {
    setCurrentReplayImage(index);
    setIsReplayViewerOpen(true);
  }, []);
  const closeReplayImageViewer = () => {
    setCurrentReplayImage(0);
    setIsReplayViewerOpen(false);
  };

  const handleDeleteComment = (e, commentId) => {
    e.stopPropagation();
    deleteComment(commentId);
  };

  const handleEditComment = async (e, comment) => {
    e.stopPropagation();

    const imagesObjectArray = await Promise.all(
      comment.images.map((image) => urlToObject(image))
    );
    commentEditImageObjectArray.current = imagesObjectArray;
    setIsEditCommentId(comment.id);
  };

  return (
    <>
      {fileData?.data?.data[0]?.comments !== undefined && (
        <Styles.Accordion
          expanded={expandedComp === 2}
          onChange={handleChangeComp(2)}
        >
          <Styles.AccordionSummary
            aria-controls="panel1d-content"
            id="panel1d-header"
          >
            <Styles.AccordionContent>
              <Styles.AccordionContentText>
                <Styles.AccordionText
                  sx={{ fontWeight: "400", fontSize: "16px" }}
                >
                  الاستفسارات
                </Styles.AccordionText>
              </Styles.AccordionContentText>
            </Styles.AccordionContent>
          </Styles.AccordionSummary>
          <Styles.AccordionDetails>
            {fileData?.data?.data[0]?.comments
              ? fileData?.data?.data[0]?.comments.map((el) => (
                  <Styles.AccordionContentVed boxshadow="none">
                    <Styles.Accordion
                      expanded={expandedCom === el.id}
                      onChange={handleChangeCom(el.id)}
                      style={{
                        width: "100%",
                        borderRadius: "4px",
                        boxShadow: "none",
                      }}
                    >
                      <Styles.AccordionSummary
                        aria-controls="panel1d-content"
                        id="panel1d-header"
                      >
                        <Styles.AccordionContent sx={{ width: "90%" }}>
                          <Styles.AccordionContentText>
                            <Styles.AccordionText
                              sx={{ fontWeight: "400", fontSize: "16px" }}
                            >
                              {el.user_image ? (
                                <img
                                  alt={el.user}
                                  style={{
                                    width: "48px",
                                    height: "48px",
                                  }}
                                  src={`https://admin.talebeduction.com/${el.user_image}`}
                                />
                              ) : (
                                <img
                                  alt=""
                                  style={{
                                    width: "48px",
                                    height: "48px",
                                  }}
                                  src={images.user}
                                />
                              )}
                            </Styles.AccordionText>
                            <Styles.AccordionContent
                              sx={{ gap: "4px", width: "100%" }}
                            >
                              <Styles.AccordionText
                                style={{
                                  fontWeight: "500",
                                  fontSize: "14px",
                                  color: "#0D0A84",
                                }}
                              >
                                {el.user}
                              </Styles.AccordionText>
                              <Styles.AccordionText
                                style={{
                                  fontWeight: "400",
                                  fontSize: "14px",
                                  width: "100%",
                                }}
                              >
                                {el?.comment}
                              </Styles.AccordionText>
                            </Styles.AccordionContent>
                          </Styles.AccordionContentText>

                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "10px",
                            }}
                          >
                            {el.images.map(({ image }, index) => (
                              <img
                                style={{
                                  width: "70px",
                                }}
                                src={image}
                                alt="question"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openImageViewer(index);
                                }}
                              />
                            ))}
                            <Box
                              sx={{
                                position: "relative",
                                zIndex: "1000",
                              }}
                            >
                              {isViewerOpen && (
                                <ImageViewer
                                  src={el.images.map(({ image }) => image)}
                                  currentIndex={currentImage}
                                  disableScroll={false}
                                  closeOnClickOutside={true}
                                  onClose={closeImageViewer}
                                />
                              )}
                            </Box>
                          </Box>
                        </Styles.AccordionContent>
                      </Styles.AccordionSummary>

                      <Styles.AccordionDetails style={{ padding: "0px  8px " }}>
                        <Styles.AccordionContentVed
                          style={{
                            padding: "0px 100px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            gap: "1rem",
                          }}
                          boxshadow="none"
                        >
                          {el?.replays?.slice(0, 1)?.map((replay) => (
                            <Styles.AccordionContentVedItems
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                              }}
                            >
                              <Styles.AccordionTextDetails
                                sx={{
                                  fontSize: "14px",
                                  color: "#333333",
                                  padding: "10px",
                                }}
                              >
                                {replay?.comment}
                              </Styles.AccordionTextDetails>

                              <Styles.AccordionContent>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "10px",
                                  }}
                                >
                                  {replay?.images?.map(
                                    (image, index) =>
                                      image && (
                                        <img
                                          style={{
                                            width: "70px",
                                          }}
                                          src={image}
                                          alt="question"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            openReplayImageViewer(index);
                                          }}
                                        />
                                      )
                                  )}
                                  <Box
                                    sx={{
                                      position: "relative",
                                      zIndex: "1000",
                                    }}
                                  >
                                    {isReplayViewerOpen && (
                                      <ImageViewer
                                        src={replay?.images?.map(
                                          (image) => image && image
                                        )}
                                        currentIndex={currentReplayImage}
                                        disableScroll={false}
                                        closeOnClickOutside={true}
                                        onClose={closeReplayImageViewer}
                                      />
                                    )}
                                  </Box>
                                </Box>
                              </Styles.AccordionContent>
                            </Styles.AccordionContentVedItems>
                          ))}
                        </Styles.AccordionContentVed>
                      </Styles.AccordionDetails>
                    </Styles.Accordion>
                  </Styles.AccordionContentVed>
                ))
              : ""}
          </Styles.AccordionDetails>
        </Styles.Accordion>
      )}
      {/*  */}
      <Styles.Accordion
        expanded={expandedComp === 3}
        onChange={handleChangeComp(3)}
      >
        <Styles.AccordionSummary
          aria-controls="panel1d-content"
          id="panel1d-header"
        >
          <Styles.AccordionContent>
            <Styles.AccordionContentText>
              <Styles.AccordionText
                sx={{ fontWeight: "400", fontSize: "16px" }}
              >
                الأسئلة قيد الأنتظار
              </Styles.AccordionText>
            </Styles.AccordionContentText>
          </Styles.AccordionContent>
        </Styles.AccordionSummary>
        <Styles.AccordionDetails>
          {fileData?.data?.data[0]?.Pending_Questions
            ? fileData?.data?.data[0]?.Pending_Questions.map((el) => (
                <Styles.AccordionContentVed boxshadow="none">
                  <Styles.Accordion
                    expanded={expandedCom === el.id}
                    onChange={handleChangeCom(el.id)}
                    style={{
                      width: "100%",
                      borderRadius: "4px",
                      boxShadow: "none",
                    }}
                  >
                    <Styles.AccordionSummary
                      aria-controls="panel1d-content"
                      id="panel1d-header"
                    >
                      <Styles.AccordionContent sx={{ width: "90%" }}>
                        <Styles.AccordionContentText>
                          <Styles.AccordionText
                            sx={{ fontWeight: "400", fontSize: "16px" }}
                          >
                            {el.user_image ? (
                              <img
                                alt={el.user}
                                style={{
                                  width: "48px",
                                  height: "48px",
                                }}
                                src={`https://admin.talebeduction.com/${el.user_image}`}
                              />
                            ) : (
                              <img
                                alt=""
                                style={{
                                  width: "48px",
                                  height: "48px",
                                }}
                                src={images.user}
                              />
                            )}
                          </Styles.AccordionText>
                          <Styles.AccordionContent
                            sx={{ gap: "4px", width: "100%" }}
                          >
                            <Styles.AccordionText
                              style={{
                                fontWeight: "500",
                                fontSize: "14px",
                                color: "#0D0A84",
                              }}
                            >
                              <span>{el.user}</span>
                              {userId === el.user_id && (
                                <>
                                  <IconButton
                                    sx={{ marginLeft: ".5rem" }}
                                    onClick={(e) => handleEditComment(e, el)}
                                  >
                                    <EditIcon
                                      sx={{ width: "1rem", height: "1rem" }}
                                      color="primary"
                                    />
                                  </IconButton>
                                  <IconButton
                                    sx={{ marginLeft: ".5rem" }}
                                    onClick={(e) =>
                                      handleDeleteComment(e, el.id)
                                    }
                                  >
                                    <DeleteIcon
                                      sx={{
                                        width: "1rem",
                                        height: "1rem",
                                        color: "red",
                                      }}
                                    />
                                  </IconButton>
                                </>
                              )}
                            </Styles.AccordionText>
                            <Styles.AccordionText
                              style={{
                                fontWeight: "400",
                                fontSize: "14px",
                                width: "100%",
                              }}
                            >
                              {el.id == isEditCommentId ? "" : el?.comment}
                              {el.id == isEditCommentId && (
                                <FileDetailsForm
                                  isEdit={true}
                                  commentText={el.comment}
                                  commentImages={
                                    commentEditImageObjectArray.current
                                  }
                                  commentId={el.id}
                                  endEdit={() => setIsEditCommentId("")}
                                />
                              )}
                            </Styles.AccordionText>
                          </Styles.AccordionContent>
                        </Styles.AccordionContentText>
                        {el.id == isEditCommentId ? (
                          <></>
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "10px",
                            }}
                          >
                            {el.images.map(({ image }, index) => (
                              <img
                                style={{
                                  width: "70px",
                                }}
                                src={image}
                                alt="question"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openImageViewer(index);
                                }}
                              />
                            ))}
                            <Box
                              sx={{
                                position: "relative",
                                zIndex: "1000",
                              }}
                            >
                              {isViewerOpen && (
                                <ImageViewer
                                  src={el.images.map(({ image }) => image)}
                                  currentIndex={currentImage}
                                  disableScroll={false}
                                  closeOnClickOutside={true}
                                  onClose={closeImageViewer}
                                />
                              )}
                            </Box>
                          </Box>
                        )}
                      </Styles.AccordionContent>
                    </Styles.AccordionSummary>
                  </Styles.Accordion>
                </Styles.AccordionContentVed>
              ))
            : ""}
        </Styles.AccordionDetails>
      </Styles.Accordion>
    </>
  );
}
